import { render, staticRenderFns } from "./devicecomp.vue?vue&type=template&id=5caa1483&scoped=true&"
import script from "./devicecomp.vue?vue&type=script&lang=js&"
export * from "./devicecomp.vue?vue&type=script&lang=js&"
import style0 from "./devicecomp.vue?vue&type=style&index=0&id=5caa1483&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa1483",
  null
  
)

export default component.exports